import { BetslipDisplayMode } from '@frontend/sports/types/components/bet-placement';
import { difference } from 'lodash-es';

import { BetslipType } from '../../core/betslip-type';
import { IBetslipBaseState } from '../store/state';

export function isLinear({ base }: { base: IBetslipBaseState }) {
    return base.displayMode === BetslipDisplayMode.Linear;
}

export function getModuleTypesOrder(typesOrder: string[]): BetslipType[] {
    // Get all valid module types
    const allTypes: BetslipType[] = [BetslipType.Combo, BetslipType.BetBuilder, BetslipType.Single, BetslipType.Teaser, BetslipType.System];

    // Get valid configured module types, skip duplicates
    const configuredTypes = typesOrder.filter((t, index): t is BetslipType => typesOrder.indexOf(t) === index && allTypes.includes(t as BetslipType));

    // Combine with missing unconfigured module types
    return [...configuredTypes, ...difference(allTypes, configuredTypes)];
}
